// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useEffect, useRef } from 'react';
import isNil from 'lodash/isNil';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { useAppErrors } from '../../../../../../../controllers/issue-adjustments/hooks/use-app-errors';
import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../../../controllers/issue-adjustments/main';
export var useOnErrorSubscription = function useOnErrorSubscription(_ref) {
  var appId = _ref.appId;
  var viewType = useViewType();
  var notifyAppRef = useRef(null);
  var _useAppErrors = useAppErrors({
      appId: appId
    }),
    appErrors = _useAppErrors.appErrors;
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useIssueAdjustmentsA = useIssueAdjustmentsActions(),
    resetAppErrors = _useIssueAdjustmentsA.resetAppErrors;
  useEffect(function () {
    var notifyApp = notifyAppRef.current;
    if (isNil(appId) || notifyApp === null || appErrors === null) {
      return;
    }
    notifyApp({
      errors: appErrors
    });
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'success',
      actionSubject: 'jiraUiModifications.appNotification',
      attributes: {
        lifecycleEvent: 'appError',
        viewType: viewType
      }
    });
    resetAppErrors({
      appId: appId
    });
  }, [createAnalyticsEvent, resetAppErrors, appErrors, appId, viewType]);
  return useCallback(function (callback) {
    notifyAppRef.current = callback;
  }, []);
};